<ng-template #template let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{ "heading-title.promo-codes" | translate }}</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body promo-list">
      @for(promoCode of promoCodeList; track $index){
      <div class="card border">
        <div class="card-body">
          <div class="d-flex">
            <img
              [src]="promoCode.imageUrl ? helper.imageUrl + promoCode.imageUrl : helper.DefaultImages.DefaultPromoCode"
              (error)="handleImageError($event)"
              alt="promo-code"
              class="avatar-lg rounded material-shadow border me-3"
            />
            <div>
              <h5 class="card-title mb-1">{{ promoCode.title }}</h5>
              <p class="text-muted mb-0">{{ promoCode.description }}</p>
              @if(promoCode.termsAndConditions && promoCode.termsAndConditions.length > 0){
              <div class="live-preview flush_accordion">
                <div ngbAccordion activeIds="static-1" [closeOthers]="true">
                  <div ngbAccordionItem class="material-shadow" id="static-1">
                    <div ngbAccordionHeader class="accordion-header border-0 bg-transparent">
                      <button ngbAccordionButton class="text-muted pt-3 pb-0 px-0">
                        <span class="me-1">{{ "label-title.more" | translate | titlecase }}</span>
                      </button>
                    </div>
                    <div ngbAccordionCollapse>
                      <div ngbAccordionBody class="p-2">
                        <h6 class="fs-13 mb-2 text-muted">{{ "heading-title.terms-and-conditions-applied" | translate | uppercase }}</h6>
                        <div class="custom-ordered-list">
                          @for (item of promoCode.termsAndConditions; track $index) {
                          <div class="list-item">
                            {{ item }}
                          </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
        <!-- end card body -->
        <div class="border-muted border-top-dashed mx-2 px-2 py-2">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="m-0">{{ "heading-title.code" | translate | titlecase }}: {{ promoCode.code }}</h5>
            <button class="btn btn-outline-secondary btn-border btn-sm px-3" (click)="applyPromo(promoCode)">{{ "button-title.apply" | translate | titlecase }}</button>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</ng-template>
